import { getRequest, putRequest, postRequest } from "./serverCall";
// import { keysToCamel } from "./objectUtils";
// import { roundToX, parseToLocaleString } from "../managrx/utils.js";

export async function getDraftLock(draftEngagementId) {
  let endpoint = `/draft_engagement_lock?q=draft_engagement_id:${draftEngagementId}`;
  let res = await getRequest(endpoint)

  if (res.data.length > 0) {
    return res.data[0];
  }
  return {locked:0};
}

export async function lockDraft(draftEngagementId) {
  let lock = await getDraftLock(draftEngagementId);

  if (lock.createdAt) {
    let endpoint = `/draft_engagement_lock/${lock.id}`;
    return putRequest(endpoint, {
      "locked":1
    });
  } else {
    let endpoint = `/draft_engagement_lock`;
    return postRequest(endpoint, {
      "draftEngagementId": draftEngagementId,
      "locked":1
    });
  }
}

export async function unlockDraft(draftEngagementId) {
  let lock = await getDraftLock(draftEngagementId);

  if (lock.createdAt) {
    let endpoint = `/draft_engagement_lock/${lock.id}`;
    return putRequest(endpoint, {
      "locked":0
    });
  }
}